module.exports = __webpack_public_path__ + "img/猫窝-3.b0436ff1.jpg";